export const isLoading = (state, getters, rootState) => {
  return state.inProgress > 0
}



// WEBPACK FOOTER //
// ./src/app/config/store/modules/ajax/getters.js